import * as Global from '../../resources/js/globais';

window.login = function () {
  var endPoint = $("#username").val().includes("@") ? "login" : "loginAd";
  let formData = $("#formAuthentication").serializeArray();
  $("#invalidData").hide();

  if (formData[0].value == "" || formData[1].value == "") {
    Swal.fire({
      text: "Os campos de usuário e senha devem ser preenchidos.",
      icon: "warning",
      width: 450,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      timer: 4000,
    });
  } else {
    $.ajax({
      url: Global.m_server + endPoint,
      type: "POST",
      data: formData,
      success: function (result) {
        if (result) {
          result.data.first_login;

          if (
            result.data.first_login === "1" ||
            result.data.first_login === 1
          ) {
            document.querySelector("#token").value = result.data.token;
            var modal = new bootstrap.Modal(
              document.querySelector("#primeiroLogin")
            );
            modal.show();
            //document.location.href = 'login';
          } else {
            formData = {
              token: result.data.token,
            };

            $.ajax({
              url: Global.m_app + "session",
              type: "POST",
              data: formData,
              success: function (result) {
                if (result) {
                  Swal.fire({
                    text: result,
                    icon: "success",
                    width: 450,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    toast: true,
                    position: "top-end",
                    timer: 2000,
                  }).then(function () {
                    document.location.href = "dashboard";
                  });
                }
              },
              error: function (err) {
                console.log("err 2", err);
                $("#invalidData").show();
              },
            });
          }
        }
      },
      error: function (err) {
        console.log("err 1", err);
        $("#invalidData").show();
      },
    });
  }
}

window.updatePassword = function () {

  let endPoint = "updatePassword";
  let formData = $("#formUpdatePassword").serializeArray();

  $("#invalidData").hide();

  if (formData[0].value == "" || formData[1].value == "") {
    Swal.fire({
      text: "Ambos os campos devem ser preenchidos.",
      icon: "warning",
      width: 450,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      timer: 3000,
    });
  } else if (formData[0].value !== formData[1].value) {
    Swal.fire({
      text: "As senhas informadas são diferentes.",
      icon: "warning",
      width: 450,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      timer: 3000,
    });
  } else if (formData[0].value.length < 6) {
    Swal.fire({
      text: "As senha deve ter pelo menos 6 caracteres.",
      icon: "warning",
      width: 450,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      timer: 3000,
    });
  } else if (!/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(formData[0].value)) {
    Swal.fire({
      text: "As senha deve conter letras e números.",
      icon: "warning",
      width: 450,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      timer: 3000,
    });
  } else {

    $.ajax({
      url: Global.m_server + endPoint,
      type: "POST",
      data: formData,
      success: function (result) {
        if (result) {
          // console.log(result);
          if (document.querySelector("#password")) {
            document.querySelector("#password").value = "";
            Swal.fire({
              text: "Senha atualizada. Refaça seu login.",
              icon: "success",
              width: 450,
              timerProgressBar: true,
              showConfirmButton: false,
              toast: true,
              position: "top-end",
              timer: 5000,
            });
          } else {
            Swal.fire({
              text: "Senha atualizada.",
              icon: "success",
              width: 450,
              timerProgressBar: true,
              showConfirmButton: false,
              toast: true,
              position: "top-end",
              timer: 5000,
            }).then(function () {
              document.location.href = "login";
            });
          }
        }
      },
      error: function (err) {
        console.log("err 1", err);
        $("#invalidData").show();
      },
    });
    if (document.querySelector("#primeiroLogin")) {
      var modal = bootstrap.Modal.getInstance(
        document.querySelector("#primeiroLogin")
      );
      modal.hide();
    }
  }
}

window.enviarEmail = function () {
  var modal = new bootstrap.Modal(document.querySelector("#resetSenha"));
  modal.show();
}

window.resetPassword = function () {

  let endPoint = "resetPassword";
  let formData = $("#formResetPassword").serializeArray();

  $("#invalidData").hide();

  if (formData[0].value == "") {
    Swal.fire({
      text: "Preencha o campo de e-mail.",
      icon: "warning",
      width: 450,
      timerProgressBar: true,
      showConfirmButton: false,
      toast: true,
      position: "top-end",
      timer: 3000,
    });
  } else {

    $.ajax({
      url: Global.m_server + endPoint,
      type: "POST",
      data: formData,
      success: function (result) {
        if (result) {

          Swal.fire({
            text: "E-mail enviado, não esqueça de olhar a caixa de spam.",
            icon: "success",
            width: 450,
            timerProgressBar: true,
            showConfirmButton: false,
            toast: true,
            position: "top-end",
            timer: 5000,
          });
        }
      },
      error: function (err) {
        console.log("err 1", err);
        $("#invalidData").show();
      },
    });

    var modal = bootstrap.Modal.getInstance(
      document.querySelector("#resetSenha")
    );
    modal.hide();
  }
}

window.validateToken = function (token) {
  let endPoint = "validateToken";
  let formData = {
    token: token,
  };

  $.ajax({
    url: Global.m_server + endPoint,
    type: "POST",
    data: formData,
    success: function (result) {
      if (result) {
        console.log(result);
      }
    },
    error: function (err) {
      console.log("err 1", err);
      $("#invalidData").show();
    },
  });
}
